import {BadgeModule} from 'primeng/badge';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {UserPresenceDirective} from './user-presence.directive';
import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ThumbnailComponent} from "./thumbnail.component";
import {SkeletonModule} from "primeng/skeleton";
import {Ripple} from "primeng/ripple";
import {AspectRatioDirective} from "../../core/directives/aspect-ratio.directive";



@NgModule({
  declarations: [ThumbnailComponent],
  exports: [ThumbnailComponent, UserPresenceDirective],
  imports: [
    CommonModule,
    BadgeModule, TooltipModule, TranslateModule, UserPresenceDirective,
    SkeletonModule,
    Ripple,
    AspectRatioDirective,
    NgOptimizedImage
  ]
})
export class ThumbnailModule { }
